import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadixSelect from '@radix-ui/react-select';
import { styled } from 'styletron-react';
import { staticColors } from '../../../const/colors/staticColors';
import { useTestIdAttribute } from '../../../hooks/useTestIdAttribute';
import { Icon } from '../../Icon/Icon';
import { textVariantStyleMap } from '../../Text/textConst';
import { FlexContainer } from '../../layout/FlexContainer';
import { InputBase } from '../InputBase/InputBase';
import { INPUT_TEXT_VARIANT, useInputStyle } from '../useInputStyles';
import { useIsErrorTestAttribute } from '../useIsErrorTestAttribute';
const StyledTrigger = styled(RadixSelect.Trigger, (p) => ({
    ...p.$style,
    paddingTop: 0,
    paddingBottom: 0,
    ':hover': {
        cursor: p.$readOnly ? 'not-allowed' : 'pointer',
    },
    ':disabled': {
        cursor: 'not-allowed',
    },
}));
const StyledValueContainer = styled('div', (p) => ({
    ...textVariantStyleMap[INPUT_TEXT_VARIANT],
    paddingTop: p.$paddingTop,
    paddingBottom: p.$paddingBottom,
    height: p.$height,
    color: p.$hasValue && !p.$isDisabled
        ? staticColors.textDark
        : staticColors.inputPlaceholder,
    minWidth: 0,
}));
const StyledIcon = styled(RadixSelect.Icon, { lineHeight: 0 });
const StyledOverflowContainer = styled('div', (p) => ({
    height: p.$height,
    overflow: 'hidden',
    textWrap: 'nowrap',
}));
export const SelectBase = ({ label, caption, tooltip, tooltipTabIndex, error = false, updated = false, warning = false, isRequiredLabel = false, gapRight = false, placeholder, triggerText, testId, readOnly = false, disabled, children, ...rootProps }) => {
    const { paddingTop: inputPaddingTop, paddingBottom: inputPaddingBottom, outline: _outline, ...inputStyle } = useInputStyle({
        isFocused: false,
        readOnly,
        warning,
    });
    const isErrorTestAttribute = useIsErrorTestAttribute(!!error);
    const testIdAttribute = useTestIdAttribute(testId);
    const stringifiedLineHeight = inputStyle.lineHeight.toString();
    const isDisabled = disabled || readOnly;
    const hasValue = Boolean(triggerText ?? rootProps.value ?? rootProps.defaultValue);
    const maybeIcon = !readOnly ? (_jsx(StyledIcon, { children: _jsx(Icon, { name: 'KeyboardArrowDown' }) })) : null;
    return (_jsxs(RadixSelect.Root, { ...rootProps, disabled: isDisabled, children: [_jsx(InputBase, { label: label, isRequiredLabel: isRequiredLabel, caption: caption, tooltip: tooltip, tooltipTabIndex: tooltipTabIndex, error: error, updated: updated, warning: warning, isFocused: false, gapRight: gapRight, testId: testId, children: _jsx(StyledTrigger, { $style: inputStyle, $readOnly: readOnly, ...testIdAttribute, ...isErrorTestAttribute, children: _jsxs(FlexContainer, { horizontalAlign: 'spaceBetween', verticalAlign: 'center', children: [_jsx(StyledValueContainer, { $paddingTop: inputPaddingTop, $paddingBottom: inputPaddingBottom, $height: stringifiedLineHeight, $hasValue: hasValue, $isDisabled: isDisabled, children: _jsx(StyledOverflowContainer, { $height: stringifiedLineHeight, children: _jsx(RadixSelect.Value, { placeholder: placeholder, children: triggerText }) }) }), maybeIcon] }) }) }), _jsx(RadixSelect.Portal, { children: children })] }));
};
